import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import { formatTitleConsumidorFinalEVS } from "../../../../helpers/formatValues";
import moment from "moment";

export const DetalleOrdenes = (props) => {
    const { produccionSeleccionada, onClose } = props;

    const opened = !!produccionSeleccionada;

    const ordenesProduccion = produccionSeleccionada
        ? produccionSeleccionada.ordenes_produccion
        : [];

    return (
        <Modal
            open={opened}
            onClose={onClose}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "1200px",
                    width: "90%",
                },
            }}
        >
            <h4 className="text-center mb-4">Detalles de producción</h4>

            {/* TABLA DE ORDENES DE PRODUCCION */}
            <div className="new-table-wrapper creacion-produccion__table-wrapper sticky-header sticky-first-column sticky-second-column">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>EVS</th>
                            <th>Cliente</th>
                            <th>Fecha de inicio</th>
                            <th>Fecha de cierre</th>
                            <th>Cerrada por</th>
                            <th>Producto</th>
                            <th>Kg a producir</th>
                            <th>Kg producidos</th>
                            <th>Kg pendientes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordenesProduccion.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={9}>
                                    No hay órdenes de producción.
                                </td>
                            </tr>
                        )}
                        {ordenesProduccion.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center">
                                        {item.evs && item.evs.numero}
                                    </td>
                                    <td
                                        className="text-center text-nowrap"
                                        title={formatTitleConsumidorFinalEVS(
                                            item.evs,
                                        )}
                                    >
                                        {item.evs &&
                                            item.evs.cliente &&
                                            item.evs.cliente.nombre}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.fecha_inicial
                                            ? moment(item.fecha_inicial).format(
                                                  "DD/MM/YYYY HH:mm",
                                              )
                                            : "—"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.fecha_final
                                            ? moment(item.fecha_final).format(
                                                  "DD/MM/YYYY HH:mm",
                                              )
                                            : "—"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue value={item.cerrada_por}>
                                            {item.cerrada_por}
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.evs &&
                                            item.evs.producto_a_producir &&
                                            item.evs.producto_a_producir.nombre}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_a_producir}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_paletizados || 0}
                                            decimalScale={2}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_pendientes || 0}
                                            decimalScale={2}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </Modal>
    );
};
